<template src="./RegisterLaboratory.html" />

<script>
import { useStore } from "@/store/store.js"
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      showContent: false,
      laboratories: undefined,
      windowWidth: 0,
      currentx: 1,
      numPages: 0,
      pagination: false,
      searchLaboratory: "",
      popupLaboratory: false,
      popupLaboratoryAddress: false,
      popupLaboratoryData: {
        active: undefined,
        id: undefined,
        name: undefined,
        addresses: [],
      },
      invalidFields: {
        name: false,
        phone: false,
        address: false,
      },
      dangerMessage: "Campo obrigatório",
      toggleActiveId : null,
      trySave :false,
      addressDisable: true,
      showRemoveAddress: false,
      indexAddressToRemove: null,
      oneAddressActive: false,
    }
  },
  setup () {
    const store = useStore()

    return {
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  mounted() {
    const vm = this;
    vm.init();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    'popupLaboratoryData.name': function(newVal) {
      const vm = this;
      vm.invalidFields.name = vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.name && vm.trySave;
    },
    'popupLaboratoryData.phone': function() {
      const vm = this;
      vm.validatePhone();
      vm.invalidFields.phone = vm.invalidFields.phone && vm.trySave;
    },
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.getLaboratories();
    },

    getLaboratories() {
      const vm = this;
      const page = vm.currentx - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
          "orizon?page=" + page + "&search=" + vm.searchLaboratory + "&size=10&sort=id,desc", {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.laboratories = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.showContent = true;
          }
        });
    },

    changePagination() {
      const vm = this;
      vm.getLaboratories();
    },

    confirmeChangeStatus(id) {
      const vm = this;
      vm.toggleActiveId = id;
      vm.$bvModal.show("modal-change-status-laboratory");
    },
    toggleActive() {
      const vm = this;
      vm.axios
        .put(
          vm.$store.state.filooServer + "orizon/toggle/" + vm.toggleActiveId, {}, {
            headers: {
            Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.$bvModal.hide("modal-change-status-laboratory");
            vm.showNotifySuccess("Operação realizada","O status do laboratório foi alterado com sucesso", 3000);
            vm.getLaboratories();
          }
        }).catch(function () {
          vm.$bvModal.hide("modal-change-status-laboratory");
          vm.showNotifyError("Não foi possível alterar o status da especialidade", 6000);
        })
        .finally(function() {
          vm.$bvModal.hide("modal-change-status-laboratory");
        });
    },
    addNewLaboratoryPopup() {
      const vm = this;
      vm.trySave = false;
      vm.invalidFields = {name:false , phone:false};
      vm.popupLaboratory = true;
      vm.popupLaboratoryData = {
        active: true,
        id: undefined,
        name: undefined,
        addresses: [{
          id: undefined,
          active: true,
          address: {
            zipcode: "",
            city: "",
            complement: "",
            neighborhood: "",
            number: "",
            state: "",
            street: "",
            disable: {
              true: true,
              neighborhood: true,
            }
          },
          laboratorio : {
            active: vm.popupLaboratoryData.active,
            name: vm.popupLaboratoryData.name,
            phone: vm.popupLaboratoryData.phone
          },
          
        }],
      }
    },

    editLaboratoryPopup(Laboratory) {
      const vm = this;
      vm.popupLaboratory = true;
      vm.trySave = true;
      vm.validatePhone();
      vm.validateAddress();
      vm.validateName();
      vm.popupLaboratoryData = {
        active: Laboratory.active,
        id: Laboratory.id,
        name: Laboratory.name,
        phone: Laboratory.phone,
        addresses: [],
      }
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "orizon/labAddress/" + Laboratory.id,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.popupLaboratoryData.addresses = response.data;
            vm.popupLaboratoryData.addresses.forEach(data => {
              data.address.disable = {street: true, neighborhood: true};
              data.address.disable.street = !vm.testNullUndefinedEmpty(data.address.street);
              data.address.disable.neighborhood = !vm.testNullUndefinedEmpty(data.address.neighborhood);
            });
          }
        });
    },

    addEndereco() {
      const vm = this;

      vm.popupLaboratoryData.addresses.push({
        id: undefined,
        address: {
          zipcode: "",
          city: "",
          complement: "",
          neighborhood: "",
          number: "",
          state: "",
          street: "",
          disable: {
            street: false,
            neighborhood: false,
          }
    },
        laboratorio : {
          active: vm.popupLaboratoryData.active,
          name: vm.popupLaboratoryData.name,
          phone: vm.popupLaboratoryData.phone
        },
        active: true
      })
      vm.trySave = false;
    },

    remEndereco() {
      const vm = this;
      if(vm.popupLaboratoryData.addresses.length < 1){
        return
      }
      vm.popupLaboratoryData.addresses.splice(vm.indexAddressToRemove, 1);
      vm.showRemoveAddress = false;
      vm.trySave = false;
    },

    addNewLaboratory() {
      const vm = this;
      vm.trySave = true;
      vm.$nextTick(() => {
        vm.removeFocus();
      });
      vm.validatePhone();
      vm.validateAddress();
      vm.validateName();
      if(!vm.invalidFields.name && !vm.invalidFields.address && !vm.invalidFields.phone) {
        let labDTO = vm.createAddressToNewLaboratory();

        vm.axios
          .post(
            vm.$store.state.filooServer + "orizon", labDTO, {
              headers: {
                Authorization: vm.$session.get("bearerDefault")
              },
            }
          )
          .then(function (response) {
            if (response.status == 200) {
              vm.sucessMessage();
            }
          })
          .catch(function () {
            vm.errorMessage();
          })
          .finally(function() {
            vm.popupLaboratory = false;
          });
      } else if (!vm.oneAddressActive) {
          vm.alertMessage();
      }
    },

    editLaboratory() {
      const vm = this;
      vm.$nextTick(() => {
        vm.removeFocus();
      });
      vm.trySave = true;
      vm.validatePhone();
      vm.validateAddress();
      vm.validateName();
      if(!vm.invalidFields.name && !vm.invalidFields.address && !vm.invalidFields.phone) {
        let labAddDTO = vm.createAddressEdit();

        vm.axios
          .put(
            vm.$store.state.filooServer + "orizon", labAddDTO, {
              headers: {
                Authorization: vm.$session.get("bearerDefault")
              },
            }
          )
          .then(function (response) {
            if (response.status == 200) {
              vm.sucessMessage();
            }
          })
          .catch(function () {
            vm.errorMessage();
          })
          .finally(function() {
            vm.popupLaboratory = false;
          });
      } else if (!vm.oneAddressActive) {
          vm.alertMessage();
      }
    },

    createAddressEdit() {
      const vm = this;
      let labAddDTO = []
        for(let x in vm.popupLaboratoryData.addresses) {
          let labAddx = {
            id: vm.popupLaboratoryData.addresses[x].id,
            active: vm.popupLaboratoryData.addresses[x].active,
            laboratorio: {
              id: vm.popupLaboratoryData.id,
              active: vm.popupLaboratoryData.active,
              name: vm.popupLaboratoryData.name,
              phone: vm.popupLaboratoryData.phone
            },
            endereco: vm.popupLaboratoryData.addresses[x].address
          }
          labAddDTO.push(labAddx);
        }
      return labAddDTO;
    },

    createAddressToNewLaboratory() {
      const vm = this;
      let labDTO = [];
      labDTO = {
          active: vm.popupLaboratoryData.active,
          laboratorio : {
            active: vm.popupLaboratoryData.active,
            name: vm.popupLaboratoryData.name,
            phone: vm.popupLaboratoryData.phone
          },
          addresses: vm.testNullUndefinedEmpty(vm.popupLaboratoryData.addresses)? 
            [] : vm.popupLaboratoryData.addresses
        }

        for(let x in labDTO.addresses) {
          labDTO.addresses[x].laboratorio = {
            active: vm.popupLaboratoryData.active,
            name: vm.popupLaboratoryData.name,
            phone: vm.popupLaboratoryData.phone
          }
          labDTO.addresses[x].endereco = labDTO.addresses[x].address
        }
      return labDTO;
    },

    sucessMessage() {
      const vm = this;
      vm.$swal({
        title: "Laboratório Salvo!",
        icon: "success",
      });
      vm.trySave = false;
      vm.getLaboratories();
    },

    errorMessage() {
      const vm = this;
      vm.$vs.notify({
        title: "Ocorreu um erro",
        text: "Laboratório não salvo",
        color: "danger",
        icon: "error",
        time: 6000
      });
    },

    alertMessage() {
      const vm = this;
      vm.$swal(
        "Atenção",
        "Pelo menos um endereço deve estar ativo.",
        "warning"
      );
    },

    changeSearchLaboratory() {
      const vm = this;
      vm.currentx = 1;
      vm.getLaboratories();
    },

    async getAddressData(zipcode, index) {
      const response = await this.getAddressByZipcode(zipcode)
      const fields = this.popupLaboratoryData.addresses[index].address

      if (response && response.address) {
        fields.street = response.address.street
        fields.city = response.address.city
        fields.state = response.address.state
        fields.neighborhood = response.address.neighborhood
      } else {
        fields.street = ""
        fields.city = ""
        fields.state = ""
        fields.neighborhood = ""

        fields.disable.street = false
        fields.disable.neighborhood = false
      }
      
      fields.disable.street = !!fields.street
      fields.disable.neighborhood = !!fields.neighborhood
    },
    addNewAddress() {
      const vm = this;
      vm.popupLaboratoryData
      let addressObj = vm.popupLaboratoryData.addresses[0];
      vm.axios
        .post(
          vm.$store.state.filooServer + "orizon/addAddress/" + vm.popupLaboratoryData.id, addressObj, {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.getLaboratories();
          }
        });
    },

    validatePhone() {
      const vm = this;
      vm.invalidFields.phone = vm.testNullUndefinedEmpty(vm.popupLaboratoryData.phone) 
      || vm.popupLaboratoryData.phone.length !== 12
    },

    validateAddress() {
      const vm = this;
      let invalid = false;
      vm.oneAddressActive = false;
      if (vm.testNullUndefinedEmpty(vm.popupLaboratoryData.addresses)) {
        vm.popupLaboratoryData.addresses = [{
          id: undefined,
          address: {
            zipcode: "",
            city: "",
            complement: "",
            neighborhood: "",
            number: "",
            state: "",
            street: "",
            disable: {
              true: true,
              neighborhood: true,
            }
          },
          laboratorio : {
            active: vm.popupLaboratoryData.active,
            name: vm.popupLaboratoryData.name,
            phone: vm.popupLaboratoryData.phone
          },
          active: true
        }];
        return vm.invalidFields.address = true;
      } 

      for(var index = 0; index < vm.popupLaboratoryData.addresses.length; index ++) {
          invalid = invalid || vm.validateStreet(index) || vm.validateNumber(index) || vm.validateNeighborhood(index) ||  vm.validateZipcode(index);
          vm.oneAddressActive = vm.popupLaboratoryData.addresses[index].active ? true : vm.oneAddressActive;
      }
      vm.invalidFields.address = invalid || !vm.oneAddressActive;
    },

    validateStreet(index) {
      const vm = this;
      let street = vm.popupLaboratoryData.addresses[index].address.street;
      let result = vm.testNullUndefinedEmpty(street) && vm.trySave;
      return result;
    },

    validateNeighborhood(index) {
      const vm = this;
      let neighborhood = vm.popupLaboratoryData.addresses[index].address.neighborhood;
      let result = vm.testNullUndefinedEmpty(neighborhood) && vm.trySave;
      return result;
    },

    validateNumber(index) {
      const vm = this;
      let number = vm.popupLaboratoryData.addresses[index].address.number;
      let result = vm.testNullUndefinedEmpty(number) && vm.trySave;
      return result;
    },

    validateZipcode(index) {
      const vm = this;
      let zipcode = vm.popupLaboratoryData.addresses[index].address.zipcode;
      let state = vm.popupLaboratoryData.addresses[index].address.state;
      let result = (vm.testNullUndefinedEmpty(zipcode) || vm.testNullUndefinedEmpty(state)) && vm.trySave;
      return result;
    },

    validateName() {
      const vm = this;
      vm.invalidFields.name = vm.testNullUndefinedEmpty(vm.popupLaboratoryData.name);
    },

    popupRemoveAddress(index) {
      const vm = this;
      vm.indexAddressToRemove = index;
      vm.showRemoveAddress = true;
    },

    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },

    removeFocus() {
      document.activeElement.blur()
    },
  }
};
</script>

<style lang="scss" src="./RegisterLaboratory.scss" />